import { BookOpen } from 'lucide-react';
import type { NavigationItem } from '@/shared/types/navigation';

export const storiesNavItems: NavigationItem[] = [
  {
    id: 'stories',
    category: 'tool',
    name: 'stories.name',
    description: 'stories.description',
    icon: BookOpen,
    href: '/stories',
  },
];
